import Route from 'cio/routes/base';
import Transition from '@ember/routing/-private/transition';
import { isEmpty } from '@ember/utils';

import NewsletterModel from 'cio/models/newsletter';
import BroadcastsNewsletterOverviewContentIndexController from 'cio/pods/broadcasts/newsletter/overview/content/index/controller';

export default class BroadcastsNewsletterOverviewContentIndexRoute extends Route {
  queryParams = {
    templateId: {
      refreshModel: true,
    },
  };

  model() {
    return this.modelFor('broadcasts.newsletter');
  }

  async afterModel(model: NewsletterModel) {
    await model.get('templates');
  }

  setupController(
    controller: BroadcastsNewsletterOverviewContentIndexController,
    model: NewsletterModel,
    transition: Transition,
  ) {
    super.setupController(controller, model, transition);

    if (isEmpty(controller.templateId)) {
      let [templateId] = model.hasMany('templates').ids();
      controller.set('templateId', templateId);
    }
  }

  resetController(
    controller: BroadcastsNewsletterOverviewContentIndexController,
    isExiting: boolean,
    transition: Transition,
  ) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.setDefaults();
    }
  }
}
